import { createWidget } from '@alfa-bank/site-util-create-widget/create-widget';

import styles from '../../styles/styles.css';
import { BannerLink } from '../banner-link';

import { SegmentLink as Component } from './segment-link';
import type { IDeps, TSegmentLink } from './models';

export const SegmentLink = createWidget<IDeps, TSegmentLink>({
    BannerLink,
    styles,
})(Component);
